import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetActiveMenu_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { Box, Grid } from "@mui/material";
import CtDtp from "./CustomTool/CtDtp";
import { Check, Delete, Edit } from "@mui/icons-material";
import TableList from "./CustomTool/TableList";
import CtCmb from "./CustomTool/CtCmb";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
// import Checkbox from './CustomTool/CtCheckBox';
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CtBtn from "./CustomTool/CtBtn";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import Menu from "./Menu";

class CompanyList extends Component {
  headerRef = React.createRef();
  state = {
    AccountYear: [],
    columns: [
      { id: "Action", label: "", name: "SelectCompany" },
      { id: "bint_acid", label: "SR NO", hide: true },
      { id: "vac_company", label: "Company Name" },
      { id: "vac_gstno", label: "GST No" },
    ],
    rows: [],
    headerH: 0,
    actionList: [
      {
        name: "SelectCompany",
        icon: "", //<CheckBoxOutlineBlankIcon color="primary" />,
        link: "CompanyList:",
        actionType: "Chk",
        CtrlProps: { behaviour: "radio" },
      },
    ],
    keyColumn: ["bint_acid", "vac_company", "vac_gstno"],

    formData: {
      bint_acid: "",
      txtCompanyName: "",
      txtGSTNo: "",
      cmbAccountYear: "",
      PreviousYear: "",
    },
    currentCompany: localStorage.getItem("CompanyName"),

    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,

    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    // document.title = "RA : Company List";
    this.props.setActiveMenu("CompanyList");
    // console.log("this.props.CompanyNameList",this.props.CompanyNameList);
    if (this.props.CompanyNameList && this.props.CompanyNameList.length > 0) {
      let rows = this.setDefaultCompany(this.props.CompanyNameList),
        rowsCount = rows.length,
        AccountYear = this.props.AcYear,
        cmbAccountYear =
          localStorage.getItem("FullACY") &&
          localStorage.getItem("FullACY").length >= 9
            ? localStorage.getItem("FullACY")
            : this.props.DefYear,
        PreviousYear = cmbAccountYear;
      this.setState(
        {
          rows,
          rowsCount,
          AccountYear,
          formData: {
            ...this.state.formData,
            cmbAccountYear: cmbAccountYear,
            PreviousYear,
          },
        },
        () => {
          // console.log("company list");
          // this.props.verifyUserID(undefined, this.props.navInfo.subMenuMaster, this.props.setSubMenu_Master_Entry, this.props.setUserPrivileges);
          this.setlocalDefaultStorage();
        }
      );
    }
  }
  //#endregion Component

  //#region Handles
  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {
      this.setCompany(handledRowIndex);
    });
  };

  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        this.setYear();

        // if (e.target.name === "cmbAccountYear") {
        //   // this.props.setDefAcYearCompany({ ACY: e.target.value });
        //   // this.state.formData.PreviousYear ===
        //   //   this.state.formData.cmbAccountYear &&
        //   // this.props.defaultCompany === this.state.currentCompany
        //   //   ? this.props.handleOnARDClose(false)
        //   //   : this.props.handleOnARDClose(true);
        // }
      }
    );
  };

  handleARDonActionClick = (row) => {
    const bint_acid = row.bint_acid,
      txtCompanyName = row.txtCompanyName,
      txtGSTNo = row.txtGSTNo,
      actionName = row.actionName;
    if (actionName === "SelectCompany") {
      localStorage.setItem("acid", bint_acid);
      localStorage.setItem("CompanyName", txtCompanyName);
      localStorage.setItem("GSTNo", txtGSTNo);
    }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };
  //#endregion Handles

  //#region Function

  setlocalDefaultStorage = () => {
    if (
      !localStorage.getItem("FullACY") ||
      localStorage.getItem("FullACY").length < 9
    ) {
      this.setYear();
    }
    if (
      (!localStorage.getItem("CompanyName") ||
        !localStorage.getItem("acid") ||
        localStorage.getItem("CompanyName").length < 0 ||
        localStorage.getItem("acid").length < 0) &&
      this.state.rows.length > 0
    ) {
      let defaultRowIndex = 0;
      this.state.rows.map((row, index) => {
        if (row.Action === true) {
          defaultRowIndex = index;
        }
      });
      this.setCompany(defaultRowIndex);
    }
    this.props.setPrevAcYearCompany({
      PrevCompanyName: localStorage.getItem("CompanyName"),
      PrevACY: localStorage.getItem("FullACY"),
    });
  };

  setCompany = (selectedRowIndex) => {
    let CompanyName = "";
    this.state.rows.map((row, rowIndex) => {
      if (rowIndex === selectedRowIndex) {
        // console.log("row", row);
        this.updateCompanyToLocalStorage({
          company: row.vac_company,
          gstno: row.vac_gstno,
          acid: row.bint_acid,
          statecode: row.vac_statecode,
          CI: row.bint_ci,
          int_ewaybill: row.int_ewaybill,
          int_einvoice: row.int_einvoice,
        });
        CompanyName = row.vac_company;
      }
    });
    // console.log("CompanyName", CompanyName);
    this.setState(
      {
        currentCompany: CompanyName,
      },
      () => {
        // this.props.setDefAcYearCompany({ CompanyName });
        // ({ CompanyName: CompanyName });
        // localStorage.setItem("currentCompany", CompanyName);
      }
    );
  };

  setYear = () => {
    if (this.validateSelectionData()) {
      localStorage.setItem("FullACY", this.state.formData.cmbAccountYear);
      let ACY = this.state.formData.cmbAccountYear.substring(0, 4);
      localStorage.setItem("ACY", ACY);
    }
  };

  updateCompanyToLocalStorage = ({
    company,
    gstno,
    acid,
    statecode,
    CI,
    int_ewaybill,
    int_einvoice,
  }) => {
    localStorage.setItem("CompanyName", company);
    localStorage.setItem("GSTNo", gstno);
    localStorage.setItem("acid", acid);
    localStorage.setItem("CompStateCode", statecode);
    localStorage.setItem("int_ewaybill", int_ewaybill);
    localStorage.setItem("int_einvoice", int_einvoice);

    // localStorage.setItem("CI", CI);
  };

  setDefaultCompany = (rows) => {
    let defaultCompany = undefined,
      defaultRowIndex = 0;
    if (this.props.defaultCompany && this.props.defaultCompany.length > 0) {
      defaultCompany = this.props.defaultCompany;
      defaultRowIndex = undefined;
    }
    rows = rows.map((row, rowIndex) => {
      if (
        (defaultCompany !== undefined && row.vac_company === defaultCompany) ||
        (defaultRowIndex !== undefined &&
          Number(defaultRowIndex) === Number(rowIndex))
      ) {
        return { ...row, Action: true };
      } else {
        return { ...row, Action: false };
      }
    });
    return rows;
  };

  measureHeader = () => {
    const el = this.headerRef?.current;
    const h = el ? Math.ceil(el.getBoundingClientRect().height) : 0;
    if (h !== this.state.headerH) this.setState({ headerH: h });
  };

  validateSelectionData = () => {
    let result = false;
    if (Number(this.state.formData.cmbAccountYear) <= 0) {
      this.props.toastErrorMsg("Select Account Year");
    } else {
      result = true;
    }
    return result;
  };
  //#endregion

  render() {
    // console.log(
    //   "this.state.formData.PreviousYear",
    //   this.state.formData.PreviousYear
    // );

    const MOBILE_HEADER_H = 64; // header ki real height jitni ho, 56/64/72 adjust kar lo

    return (
      <Box
        sx={{
          height: { xs: "100dvh", sm: "auto" },
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          bgcolor: "background.paper",
        }}
      >
        {/* Freeze Account Year on mobile */}
        <Box
          sx={{
            position: { xs: "fixed", sm: "static" }, // 👈 mobile = fixed
            top: 0,
            left: 0,
            right: 0,
            zIndex: (t) => t.zIndex.appBar + 1,
            bgcolor: "background.paper",
            p: "8px 16px",
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <CtCmb
                id="cmbAccountYear"
                label="Account Year"
                items={this.state.AccountYear}
                value={this.state.formData.cmbAccountYear}
                handleOnChange={this.handleOnChange}
                width={110}
                maxLength={50}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Scroll area */}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
            px: 1,
            py: 1,
            mt: { xs: `${MOBILE_HEADER_H}px`, sm: 0 }, // 👈 header ke offset ke liye
          }}
        >
          <Grid item>
            <TableList
              columns={this.state.columns}
              counter={this.state.counter}
              rows={this.state.rows}
              rowsCount={this.state.rowsCount}
              rowsPerPage={this.state.rowsPerPage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              handleOnActionClick={this.handleARDonActionClick}
              actionList={this.state.actionList}
              keyColumn={this.state.keyColumn}
              handleOnSearchChange={this.handleOnSearchChange}
              searchColumns={this.state.searchColumns}
              searchData={this.state.searchData}
              handleOnNewEntryClick={this.handleOnNewEntryClick}
              handleOnRowDataChange={this.handleOnRowDataChange}
            />
          </Grid>
        </Box>

        {/* Bottom bar */}
        <Box
          sx={{
            position: { xs: "sticky", sm: "static" },
            bottom: { xs: 0, sm: "auto" },
            bgcolor: "background.paper",
            borderTop: { xs: "1px solid", sm: "none" },
            borderColor: "divider",
            p: 1,
            textAlign: "right",
          }}
        >
          {this.state.ARD}
        </Box>
      </Box>
    );

    // return (
    //   <>
    //     <Box
    //       sx={{
    //         position: "sticky",
    //         top: 0,
    //         zIndex: 10,
    //         backgroundColor: "white",
    //         padding: "8px 16px",
    //       }}
    //     >
    //       <Grid
    //         container
    //         direction="row"
    //         justifyContent={
    //           // this.state.formData.PreviousYear ==
    //           //   this.state.formData.cmbAccountYear &&
    //           // this.props.defaultCompany == this.state.currentCompany
    //           //   ?
    //           "center"
    //           // : "space-between"
    //         }
    //         alignItems="center"
    //         spacing={2}
    //         marginTop={0}
    //         marginBottom={0}
    //       >
    //         <Grid item>
    //           <CtCmb
    //             id="cmbAccountYear"
    //             label="Account Year"
    //             items={this.state.AccountYear}
    //             value={this.state.formData.cmbAccountYear}
    //             handleOnChange={this.handleOnChange}
    //             width={110}
    //             maxLength={50}
    //           />
    //         </Grid>
    //         {/* {
    //           this.state.formData.PreviousYear ==
    //             this.state.formData.cmbAccountYear &&
    //           this.props.defaultCompany == this.state.currentCompany &&
    //           this.props.handleOnARDClose
    //             ? this.props.handleOnARDClose(false)
    //             : // <Grid item marginTop={1}>
    //               //   <CtBtn
    //               //     label={"Apply Changes"}
    //               //     onClick={() => {
    //               // if (this.props.handleOnARDClose) {
    //               this.props.handleOnARDClose(true)
    //           // }
    //           //   }}
    //           // />
    //           // </Grid>
    //         } */}
    //       </Grid>
    //     </Box>
    //     <br />

    //     <Box
    //       sx={{
    //         maxHeight: "300px", // Adjust as per your modal height
    //         overflowY: "auto",
    //       }}
    //     >
    //       <Grid item>
    //         <TableList
    //           columns={this.state.columns}
    //           counter={this.state.counter}
    //           rows={this.state.rows}
    //           rowsCount={this.state.rowsCount}
    //           rowsPerPage={this.state.rowsPerPage}
    //           handleChangeRowsPerPage={this.handleChangeRowsPerPage}
    //           handleOnActionClick={this.handleARDonActionClick}
    //           actionList={this.state.actionList}
    //           keyColumn={this.state.keyColumn}
    //           handleOnSearchChange={this.handleOnSearchChange}
    //           searchColumns={this.state.searchColumns}
    //           searchData={this.state.searchData}
    //           handleOnNewEntryClick={this.handleOnNewEntryClick}
    //           handleOnRowDataChange={this.handleOnRowDataChange}
    //         />
    //       </Grid>
    //     </Box>

    //     <Grid item>
    //       <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
    //         {this.state.ARD}
    //       </Box>
    //     </Grid>
    //   </>
    // );
  }
}

export default withRouter(
  connect(
    mapStatetoProps,
    mapSetActiveMenu_MenuVisibility_ToProps
  )(HOCVerifyIsUser(HoCtToastContainer(CompanyList)))
);
